import React, { FC } from "react";
import { useSelector, useDispatch } from "react-redux";
import Logo from "shared/Logo/Logo";
import { NavLink } from "react-router-dom";
import Navigation from "shared/Navigation/Navigation";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import MenuBar from "shared/MenuBar/MenuBar";
import Badge from "@mui/material/Badge";
// import SwitchDarkMode from "shared/SwitchDarkMode/SwitchDarkMode";
import HeroSearchForm2MobileFactory from "components/HeroSearchForm2Mobile/HeroSearchForm2MobileFactory";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import { userActions } from "store/user";
import { useNavigate } from "react-router-dom";
import CelebrationOutlinedIcon from "@mui/icons-material/CelebrationOutlined";
import { logoutUser } from "store/user";
import { cart } from "store/cartSlice";

export interface MainNav1Props {
  className?: string;
}

const MainNav1: FC<MainNav1Props> = ({ className = "" }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const isAuth = useSelector((state: any) => state.user.isAuthenticated);
  const user = useSelector((state: any) => state.user.user);
  const dispatch = useDispatch();
  const cartItems = useSelector((state: any) => state.cart.cart);
  const subscription = useSelector((state: any) => state.user.subscription);
  const subscriptionStatus = useSelector(
    (state: any) => state.user.subscriptionStatus
  );

  const getQuantity = () => {
    let quantity = 0;
    cartItems?.forEach((item: any) => (quantity += item.quantity));
    return quantity;
  };

  const cartCount = getQuantity();
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const goToCheckout = () => {
    navigate("/checkout");
  };

  const logOut = () => {
    localStorage.clear();
    dispatch(logoutUser());
    dispatch(cart([]));
    navigate("/");
  };

  // Randomly pick a gradient for avatar
  const avatarGradients = [
    "linear-gradient(to right bottom, #FF9671, #FFC75F)",
    "linear-gradient(to right bottom, #845EC2, #D65DB1)",
    "linear-gradient(to right bottom, #FF6F91, #FF9671)",
    "linear-gradient(to right bottom, #00C9A7, #C4FCEF)",
  ];

  const randomGradient = React.useMemo(() => {
    return avatarGradients[Math.floor(Math.random() * avatarGradients.length)];
  }, []);

  return (
    <div className={`nc-MainNav1 relative z-10 ${className}`}>
      <div
        className="px-4 lg:container py-4 lg:py-5 relative flex justify-between items-center"
        style={{ paddingLeft: "0px" }}
      >
        <div
          className="hidden md:flex justify-start flex-1 items-center space-x-4 sm:space-x-10"
          style={{ height: "60px" }}
        >
          <Logo />
          <Navigation />
        </div>

        <div className="lg:hidden flex-[3] max-w-lg !mx-auto md:px-3">
          <HeroSearchForm2MobileFactory />
        </div>

        {!isAuth ? (
          <div className="hidden md:flex flex-shrink-0 items-center justify-end flex-1 lg:flex-none text-neutral-700 dark:text-neutral-100">
            <div className="hidden xl:flex items-center space-x-0.5">
              {/* <SwitchDarkMode /> */}
              <div className="px-1" />
              <ButtonPrimary href="/login">Εγγραφή/Σύνδεση</ButtonPrimary>
              <ButtonSecondary href="/subscription">
                Γίνε Συνεργάτης
              </ButtonSecondary>
              <div className="px-1" />
            </div>
            <div className="flex xl:hidden items-center">
              {/* <SwitchDarkMode /> */}
              <div className="px-0.5" />
              <MenuBar />
            </div>
          </div>
        ) : (
          <>
            <div className="hidden md:flex flex-shrink-0 items-center justify-end flex-1 lg:flex-none text-neutral-700 dark:text-neutral-100">
              <IconButton
                onClick={goToCheckout}
              >
                <Badge badgeContent={cartCount} color="primary">
                  <ShoppingCartIcon
                    className="cursor-pointer"
                    sx={{
                      fontSize: 35,
                      color: "#FF6F91",
                      transition: "all 0.3s ease",
                      animation:
                        cartCount > 0
                          ? "cartBounce 2s infinite ease-in-out"
                          : "none",
                    }}
                  />
                </Badge>
              </IconButton>
            </div>
            <div className="flex hidden sm:block lg:hidden items-center">
              {/* <SwitchDarkMode /> */}
              <div className="px-0.5" />
              <MenuBar />
            </div>
            {/* <SwitchDarkMode /> */}
            <div>
              <IconButton
                onClick={handleClick}
                size="small"
                sx={{ ml: 2 }}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <Avatar
                  sx={{
                    width: 48,
                    height: 48,
                    background: randomGradient,
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      transform: "scale(1.1)",
                    },
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  {user?.user?.first_name?.charAt(0) ||
                    user?.first_name?.charAt(0)}
                  {user?.user?.last_name?.charAt(0) ||
                    user?.last_name?.charAt(0)}
                </Avatar>
              </IconButton>

              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 4,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 4px 12px rgba(0,0,0,0.15))",
                    mt: 1.5,
                    borderRadius: "16px",
                    background: "#FFF9F0",
                    border: "2px solid #FFE3B8",
                    "& .MuiMenuItem-root": {
                      borderRadius: "12px",
                      margin: "4px 8px",
                      transition: "all 0.2s ease",
                      "&:hover": {
                        backgroundColor: "rgba(255, 227, 184, 0.5)",
                        transform: "translateY(-2px)",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)",
                      },
                    },
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 12,
                      height: 12,
                      bgcolor: "#FFE3B8",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                      borderTop: "2px solid #FFE3B8",
                      borderLeft: "2px solid #FFE3B8",
                    },
                    "&:after": {
                      content: '""',
                      position: "absolute",
                      bottom: -10,
                      right: -10,
                      width: 60,
                      height: 60,
                      background:
                        "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M55 5C40 20 40 40 55 55' stroke='%23FFE3B8' stroke-width='5' stroke-linecap='round'/%3E%3Cpath d='M40 20C30 30 30 45 40 55' stroke='%23FFE3B8' stroke-width='5' stroke-linecap='round'/%3E%3Cpath d='M25 35C20 40 20 50 25 55' stroke='%23FFE3B8' stroke-width='5' stroke-linecap='round'/%3E%3C/svg%3E\")",
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      zIndex: -1,
                      opacity: 0.7,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem sx={firstMenuItem}>
                  <Avatar
                    sx={{
                      width: 48,
                      height: 48,
                      background: randomGradient,
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    {user?.user?.first_name?.charAt(0)}
                    {user?.user?.last_name?.charAt(0)}
                  </Avatar>
                  <div
                    style={{
                      flex: "1",
                      minWidth: 0,
                      marginRight: "8px",
                      overflow: "hidden",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: 700,
                        fontSize: 18,
                        maxWidth: 200,
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        margin: 0,
                        lineHeight: 1.2,
                      }}
                    >
                      {user?.user?.first_name} {user?.user?.last_name}
                    </p>
                    <span
                      style={{
                        fontWeight: 100,
                        fontSize: 14,
                        display: "block",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {user?.user.email}
                    </span>
                  </div>
                  { open && <CelebrationOutlinedIcon
                    sx={{
                      ml: "auto",
                      color: "#FF9671",
                      flexShrink: 0,
                      animation: "wave 2s infinite"
                    }}
                  />
                  }
                </MenuItem>
                <Divider
                  sx={{
                    borderColor: "#FFE3B8",
                    borderStyle: "dashed",
                    my: 1,
                    mx: 2,
                  }}
                />
                <MenuItem>
                  <Person2OutlinedIcon sx={{ mr: 2, color: "#845EC2" }} />
                  <NavLink to="/account">Το προφίλ μου</NavLink>
                </MenuItem>
                <MenuItem>
                  <ConfirmationNumberOutlinedIcon
                    sx={{ mr: 2, color: "#FF6F91" }}
                  />
                  <NavLink to="/my-bookings">Οι κρατήσεις μου</NavLink>
                </MenuItem>
                {subscriptionStatus === "active" && (
                  <MenuItem>
                    <CardMembershipIcon sx={{ mr: 2, color: "#00C9A7" }} />
                    <NavLink to="/my-subscription">Η συνδρομή μου</NavLink>
                  </MenuItem>
                )}
                {/* <MenuItem>Settings</MenuItem> */}
                <MenuItem onClick={logOut} sx={{ mt: 1 }}>
                  <LogoutOutlinedIcon sx={{ mr: 2, color: "#FF9671" }} />
                  Αποσύνδεση
                </MenuItem>
              </Menu>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MainNav1;

const firstMenuItem = {
  padding: 2,
  cursor: "auto",
  display: "flex",
  alignItems: "center",
  "&:hover": {
    backgroundColor: "transparent",
  },
};
